<app-container type="light">
	<div class="px-2 py-2">
		<div class="pb-4 mb-4 border-b border-grey-light">
			<div class="flex justify-between">
				<div class="flex flex-row gap-5 items-center">
					<h4>
						<span *ngIf="currentUndertaking.type !== 'debt'"
							>Subject of undertaking</span
						>
						<span *ngIf="currentUndertaking.type === 'debt'">Bill or Debt</span>
						({{ currentUndertaking.subject }})
					</h4>
					<app-button
						btn="tertiary"
						[icon]="ICON.EDIT"
						(click)="editUndertaking(currentUndertaking)"
					></app-button>
				</div>
				<app-button
					btn="tertiary"
					[holdable]="true"
					[icon]="ICON.DELETE"
					(onClick)="removeUndertaking(currentUndertaking)"
				></app-button>
			</div>
			<div *ngIf="currentUndertaking.child">
				<app-anchor
					[url]="childUrl"
					type="static"
					*ngIf="currentUndertaking.type === 'encumbrance'"
					>View encumbrance</app-anchor
				>
				<app-anchor
					[url]="childUrl"
					type="static"
					*ngIf="currentUndertaking.type === 'debt'"
					>View debts</app-anchor
				>
			</div>
		</div>
		<div class="grid grid-cols-6 gap-y-5">
			<div class="col-span-2">
				Status<br />
				<strong>{{
					currentUndertaking.fulfilled ? 'Fulfilled' : 'Outstanding'
				}}</strong>
			</div>
			<div *ngIf="currentUndertaking.type === 'encumbrance'" class="col-span-2">
				Registered on<br />
				<strong>{{ currentUndertaking.child?.registrationDate | date }}</strong>
			</div>
			<div *ngIf="currentUndertaking.type === 'debt'" class="col-span-2">
				Debt amount<br />
				<strong>{{ currentUndertaking.child?.amount | centsToDollars }}</strong>
			</div>
			<div class="col-span-2">
				Follow-up date<br />
				<strong>{{ currentUndertaking.followUp | date: 'longDate' }}</strong>
			</div>
			<div class="col-span-3" *ngIf="currentUndertaking.type === 'encumbrance'">
				Discharged by instrument number<br />
				<strong>{{
					currentUndertaking.child?.dischargedInstrumentNumber
				}}</strong>
			</div>
			<div
				class="col-span-3 ml-7"
				*ngIf="currentUndertaking.type === 'encumbrance'"
			>
				Discharge registered on<br />
				<strong>{{ currentUndertaking.child?.registeredOnDate | date }}</strong>
			</div>
			<div class="col-span-6">
				Subject of undertaking<br />
				<strong>{{ parsedText }}</strong>
			</div>

			<div
				class="col-span-6"
				*ngFor="
					let relatedInstrument of currentUndertaking?.relatedInstruments
						| keyvalue;
					let i = index
				"
			>
				Related Instrument ({{ i + 1 }})<br />
				<strong>{{
					relatedInstrumentsParsedText[relatedInstrument.key]
				}}</strong>
			</div>
		</div>
	</div>
</app-container>
